export const COLORS = {
  primary: {
    main: '#6366F1',
    hover: '#4F46E5',
    disabled: '#C7D2FE',
    light: '#EEF2FF'
  },
  neutral: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937'
  },
  success: {
    light: '#ECFDF5',
    text: '#047857'
  },
  error: {
    light: '#FEF2F2',
    main: '#EF4444',
    hover: '#DC2626',
    text: '#B91C1C'
  }
};
